module.exports = __webpack_public_path__ + "static/media/IMG_2908.c8fb8de6.jpg";